import React from "react";
import { useTranslation } from "react-i18next";

interface MerchantHomeErrorStateProps {
  message?: string | null;
  onRetry: () => void;
  className?: string;
}

export const MerchantHomeErrorState: React.FC<MerchantHomeErrorStateProps> = ({
  message,
  onRetry,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 rounded-2xl border border-gray-200 bg-white px-6 py-10 text-center dark:border-gray-700 dark:bg-gray-800 ${className ?? ""}`}
      role="alert"
    >
      <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
        {t("ui.something_went_wrong")}
      </p>
      {message ? (
        <p className="max-w-md text-sm text-gray-500 dark:text-gray-400">{message}</p>
      ) : null}
      <button
        type="button"
        onClick={onRetry}
        className="rounded-md border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-semibold text-emerald-700 transition-opacity hover:opacity-80 dark:border-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300"
      >
        {t("ui.retry")}
      </button>
    </div>
  );
};
